<template src="./overlay.html"></template>

<script>
  import Spinner from '../spinner/spinner.vue'

  export default {
    name: 'overlay',
    components: {
      'app-loader': Spinner
    }
  }
</script>

<style scoped>
  .overlay {
    position: fixed;
    z-index: 999;
    height: 2em;
    width: 2em;
    overflow: show;
    margin: auto;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  }

  .overlay:before {
    content: '';
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: var(--color-bg-page);
  }
</style>
